// extracted by mini-css-extract-plugin
export default {"loading":"Body_loading__PZKJ-","error":"Body_error__0KJX9","no-report-selected":"Body_no-report-selected__IfI1K"};